import React from 'react';
import { cn } from '@/lib/utils';
import { RefreshCw } from 'lucide-react';

interface PreviewContainerProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  onRefresh?: () => void;
}

const PreviewContainer: React.FC<PreviewContainerProps> = ({
  title,
  children,
  className,
  onRefresh
}) => {
  return (
    <div className={cn("bg-gray-50 rounded-lg border", className)}>
      <div className="p-4 border-b bg-white rounded-t-lg">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-medium text-gray-600 flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            {title}
          </h3>
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="text-gray-500 hover:text-gray-700 transition-colors duration-200 flex items-center gap-1 text-sm"
              type="button"
            >
              <RefreshCw className="h-3 w-3" />
              Refresh Preview
            </button>
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PreviewContainer; 